import { NetworkRequestState } from '../baseTypes';
import { TwoFactorAuthWidgetData, TwoFactorAuthWidgetStep } from './types';

export const defaultTwoFactorAuthWidgetState: TwoFactorAuthWidgetData = {
  canEnable: true,
  enabled: false,
  confirmed: false,
  secretUrl: '',
  secret: '',
  recoveryCodes: [],
  step: TwoFactorAuthWidgetStep.NotEnabled,
  submitRequest: {
    status: NetworkRequestState.IDLE,
  },
};
